
import SignContextProvider from "../../../contextApi/SignContext";
import { useContext, useEffect, useRef } from "react";
import { AppContext } from "../../../contextApi/ContextApi";
import { media } from "../../../dataSets/media";

export default function SignForm({childForm, header, isClient}) {
    const {primary_color, accent_color, currentWebsite} = useContext(AppContext);
    const headerRef = useRef();
    useEffect(()=>{
        if(!headerRef || !headerRef.current) return;
        headerRef.current.scrollIntoView({
            behavior: "smooth"
        });
    },[])
    return (
        <SignContextProvider>
            <div style={{background:!isClient&&`url(${media.main_bg})`, paddingTop:isClient?"0":"50px", opacity:"0.8", width:"100%"}}>
                <h1 ref={headerRef} style={{margin:"40px auto 0", color:isClient?accent_color:"rgba(10,90,210,1)", textShadow:`2px 2px 4px ${isClient?primary_color:"black"}`}} dir="rtl">{header}{isClient ? currentWebsite?.settings?.website_name : "Webingo!"}</h1>
                {childForm}
            </div>
        </SignContextProvider>
    )
}
